module.exports = __webpack_public_path__ + "img/bg.7fb5c90e.jpg";